import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { companyInfo } from '../data/mock';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    if (!message.trim()) return;
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = companyInfo.whatsapp.replace(/\+/g, '');
    const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(url, '_blank');
    setMessage('');
    setIsOpen(false);
  };

  const quickMessages = [
    "I need help with my CSCS card",
    "Tell me about NVQ courses",
    "CPCS training enquiry",
    "Book a course"
  ];

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {isOpen && (
          <div className="bg-white rounded-lg shadow-2xl mb-4 w-80 md:w-96 animate-in slide-in-from-bottom">
            {/* Header */}
            <div className="bg-green-600 text-white p-4 rounded-t-lg flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-white rounded-full p-2">
                  <MessageCircle className="text-green-600" size={24} />
                </div>
                <div>
                  <h3 className="font-bold">Construction Cards Helpline</h3>
                  <p className="text-xs text-green-100">Typically replies instantly</p>
                </div>
              </div>
              <button 
                onClick={() => setIsOpen(false)}
                className="hover:bg-green-700 rounded-full p-1 transition-colors"
              >
                <X size={20} />
              </button>
            </div>

            {/* Chat Body */}
            <div className="p-4 bg-gray-50 max-h-96 overflow-y-auto">
              {/* Welcome Message */}
              <div className="bg-white rounded-lg p-3 shadow-sm mb-3">
                <p className="text-sm text-gray-700 mb-2">
                  👋 Hi there! How can we help you today?
                </p>
                <p className="text-xs text-gray-500">
                  Click on a quick message or type your own:
                </p>
              </div>

              {/* Quick Reply Buttons */}
              <div className="space-y-2 mb-4">
                {quickMessages.map((msg, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setMessage(msg);
                    }}
                    className="w-full text-left bg-white border border-gray-200 rounded-lg px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:border-green-300 transition-colors"
                  >
                    {msg}
                  </button>
                ))}
              </div>

              {/* Custom Message Input */}
              <div className="bg-white rounded-lg p-3 shadow-sm">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message here..."
                  className="w-full border border-gray-200 rounded-md p-2 text-sm resize-none focus:outline-none focus:border-green-500"
                  rows="3"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                />
                <button
                  onClick={handleSendMessage}
                  className="mt-2 w-full bg-green-600 text-white py-2 rounded-md font-medium hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
                >
                  <Send size={18} />
                  Send on WhatsApp
                </button>
              </div>

              {/* Contact Info */}
              <div className="mt-4 text-center">
                <p className="text-xs text-gray-500">
                  Or call us: <a href={`tel:${companyInfo.phone}`} className="text-green-600 font-semibold hover:underline">{companyInfo.phone}</a>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Toggle Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-green-600 text-white rounded-full p-4 shadow-lg hover:bg-green-700 transition-all hover:scale-110 flex items-center gap-2"
          aria-label="Open WhatsApp chat"
        >
          {isOpen ? (
            <X size={28} />
          ) : (
            <>
              <MessageCircle size={28} />
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
                1
              </span>
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default WhatsAppWidget;
